import {mapLegacyPagination} from '@/store/utils'
import * as mutationTypes from './mutation-types'
import api from '@/store/api/customer/contact'

const initialState = () => ({
    contacts: {
        data: [],
        pagination: {}
    }
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        contacts: state => state.contacts.data,
        pagination: state => state.contacts.pagination
    },
    actions: {
        /**
         * @param {{customerId: number, params: {}}} data
         * @returns {Promise<*>}
         */
        listContacts: async ({commit, dispatch}, data) => {
            try {
                const response = await api.listContacts(data)
                const contacts = {
                    ...response,
                    pagination: mapLegacyPagination(response.pagination)
                }
                commit(mutationTypes.SET_CONTACTS, contacts)
                return contacts
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetContacts: ({commit}) => commit(mutationTypes.RESET_CONTACTS)
    },
    mutations: {
        [mutationTypes.RESET_CONTACTS]: (state) => Object.assign(state, initialState()),
        [mutationTypes.SET_CONTACTS]: (state, data) => state.contacts = data
    }
}
